function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.857 22H4.143A2.143 2.143 0 012 19.857V4.143C2 2.959 2.96 2 4.143 2h15.714C21.041 2 22 2.96 22 4.143v15.714C22 21.041 21.04 22 19.857 22zm-9.138-4.378l8.215-8.214a.714.714 0 000-1.01l-1.01-1.01a.714.714 0 00-1.01 0l-6.7 6.699-3.127-3.128a.714.714 0 00-1.01 0l-1.01 1.01a.714.714 0 000 1.01l4.642 4.643a.714.714 0 001.01 0z",
  fill: "#adc6ca"
});

function SvgAtomIconCheckedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgAtomIconCheckedinline;